import { get } from '@bigyouth/base'

const trainingSearch = () => {
  return {
    applyFilters: (searchInstance, wantedSearchState) => {
      const searchState = searchInstance.renderState[`${searchInstance.indexName}`]
      const themes = searchState.menu['themes.name']
      const subthemes = searchState.menu['themes.subTheme.name']
      const period = searchState.range['courses.startDate']
      /* eslint-disable */
      const daysCount = searchState.refinementList['daysCount']
      const certifs = searchState.refinementList['training_diploma']
      const trainingModality = searchState.refinementList['training_modality']
      /* eslint-enable */

      wantedSearchState.forEach(item => {
        if (item.attribute === 'courses.startDate') {
          const start = item.refinements[0]
          const end = item.refinements[1]

          if (end !== null) {
            period.refine([start.value, end.value])
          } else {
            period.refine([start.value])
          }
        } else {
          item.refinements.forEach(refinement => {
            if (item.attribute === 'daysCount') {
              daysCount.refine(refinement.value)
            } else if (item.attribute === 'training_diploma') {
              certifs.refine(refinement.value)
            } else if (item.attribute === 'training_modality') {
              trainingModality.refine(refinement.value)
            } else if (item.attribute === 'themes.name') {
              themes.refine(refinement.value)
            } else if (item.attribute === 'themes.subTheme.name') {
              subthemes.refine(refinement.value)
            }
          })
        }
      })
    },

    saveFilters: (searchInstance) => {
      const newSorting = get('[js-training-list-sort] select').value
      const pagination = get('.ais-Pagination-item--selected a').dataset.value
      const querySearchBox = searchInstance.renderState[`${searchInstance.indexName}`].searchBox.query

      sessionStorage.setItem('filters', JSON.stringify(searchInstance.renderState[`${searchInstance.indexName}`].currentRefinements.items))
      sessionStorage.setItem('sort', newSorting)
      sessionStorage.setItem('pagination', pagination)
      sessionStorage.setItem('querySearchBox', querySearchBox)
    },
  }
}

export default trainingSearch()
